// extracted by mini-css-extract-plugin
export default {"dialog":"UpdateLicenseDialog__dialog--2zmwQ","content":"UpdateLicenseDialog__content--XkDMj"};